<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="search()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/attendance/statistic', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="getListData()">搜索</el-button>
			</template>
			<template #actions><el-button plain v-if="$checkBtnPermission('/attendance/statistic', 'export')" size="small" type="warning" class="el-icon-download" @click="handleExportData()" :loading="exportLoading">导出</el-button></template>
			<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="员工：">
					<el-select v-model="formInline.userKeyId" placeholder="请先选择门店" clearable filterable size="small" :disabled="!formInline.storeKeyId">
						<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="月份">
					<el-date-picker
						v-model="dateStr"
						type="month"
						size="small"
						:default-value="new Date()"
						:editable="false"
						:clearable="false"
						placeholder="请选择月份"
						format="yyyy-MM"
						@change="dateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<span class="content_title">
				{{ title }}
			</span>

			<div class="table-shell">
				<el-table :cell-class-name="$moneyCellClass"
					ref="table"
					v-loading="loading"
					:data="listData"
					border
					stripe
					:highlight-current-row="true"
					empty-text="暂无数据"
					:header-cell-style="{fontWeight: 600}"
					:max-height="tableMaxHeight"
				>
					<el-table-column prop="rowNumber" label="序号" align="center" width="80"></el-table-column>
					<el-table-column prop="storeName" label="门店名称" min-width="120" align="center"></el-table-column>
					<el-table-column prop="userName" label="打卡员工" width="100" align="center"></el-table-column>
					<el-table-column v-for="m in new Date(formInline.year, formInline.month, 0).getDate()" :key="m" :label="m + '号'" width="150" align="center">
						<el-table-column prop="listMorningTime[m-1]" label="上午" width="70" align="center">
							<template #default="scope">
								<span v-if="scope.row.listMorningTime && scope.row.listMorningTime.length > 0 && scope.row.listMorningTime[m - 1] && scope.row.listMorningTime[m - 1].length > 0">
									<span v-for="value in scope.row.listMorningTime[m - 1]" :key="'morning' + m + value" class="tag tag-success">
										{{ value }}
									</span>
								</span>
								<span v-else class="text-red">×</span>
							</template>
						</el-table-column>
						<el-table-column prop="listAfternoonTime[m-1]" label="下午" width="70" align="center">
							<template #default="scope">
								<span v-if="scope.row.listAfternoonTime && scope.row.listAfternoonTime.length > 0 && scope.row.listAfternoonTime[m - 1] && scope.row.listAfternoonTime[m - 1].length > 0">
									<span v-for="value in scope.row.listAfternoonTime[m - 1]" :key="'afternoon' + m + value" class="tag tag-success">
										{{ value }}
									</span>
								</span>
								<span v-else class="text-red">×</span>
							</template>
						</el-table-column>
					</el-table-column>
				</el-table>
			</div>
		</topTab>
	<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetAttendanceStatistic, ExportAttendanceStatistic } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import { MyDebounce } from "@/utils/util.js";

export default {
	components: { exportBlockDialog },
	data() {
		return {
			loading: false,
			exportLoading: false, // 导出按钮 loading
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "考勤统计"
				}
			],
			listData: [],
			formInline: {
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1,
				storeKeyId: "",
				userKeyId: ""
			},
			title: "门店考勤统计",
			storeList: [],
			userList: [], // 员工列表
			dateStr: new Date(),
			storeName: "",
			tableMaxHeight: 500,
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	created() {
		this.getListData();
		this.GetOrgInfoListByConfig();
	},
	mounted() {
		this.updateTableHeight();
		window.addEventListener("resize", this.updateTableHeightDebounced);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.updateTableHeightDebounced);
	},
	computed: {
		updateTableHeightDebounced() {
			return MyDebounce(this.updateTableHeight, 100);
		}
	},
	methods: {
		changePages() {},
		// 计算表格最大高度：根据表格距顶部位置动态撑满可视区剩余空间，底部留出边距
		updateTableHeight() {
			this.$nextTick(() => {
				const el = this.$refs.table && this.$refs.table.$el;
				const top = el ? el.getBoundingClientRect().top : 220;
				const h = window.innerHeight - top - 24;
				this.tableMaxHeight = h > 300 ? h : 300;
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			this.title = this.formInline.year + "年" + this.formInline.month + "月" + this.storeName + "门店考勤统计";
			GetAttendanceStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data.items;
						// 数据更新后，使用$nextTick确保DOM已更新，然后调用doLayout重绘表格，修复固定列偏移问题
						this.$nextTick(() => {
							if (this.$refs.table) {
								this.$refs.table.doLayout();
								this.updateTableHeight();
							}
						});
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 搜索事件
		search() {
			this.getListData();
		},
		// 门店选择器change事件
		handleStoreChange(val) {
			if (this.storeList.length > 0) {
				const foundStore = this.storeList.find((item) => item.keyId === val);
				this.storeName = foundStore ? foundStore.value : "";
			}
			// 清空已选员工
			this.formInline.userKeyId = "";
			// 根据门店获取员工列表
			if (val) {
				this.getUserListByStore(val);
			} else {
				this.userList = [];
			}
			this.getListData();
		},
		// 日期选择器change事件
		dateChange() {
			this.formInline.year = this.dateStr.getFullYear();
			this.formInline.month = this.dateStr.getMonth() + 1;
			this.getListData();
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取门店信息失败!");
				});
		},
		// 根据门店获取人员列表
		getUserListByStore(storeKeyId) {
			const paramer = {
				keyId: storeKeyId
			};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.userList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取人员信息失败!");
				});
		},
		// 导出数据
		handleExportData() {
			this.$confirm("确定导出考勤统计数据吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					exportWithLoading(this, "exportLoading", () => ExportAttendanceStatistic(this.formInline), "导出失败，请稍后再试！").then(() => {
						this.loading = false;
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消导出"
					});
				});
		}
	}
};
</script>

<style scoped lang="scss">
.content_title {
	font-size: 32px;
	font-weight: 700;
	display: block;
	text-align: center;
	margin-bottom: 20px;
}

.table-shell {
	background: var(--app-surface);
	border: 1px solid var(--app-border);
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
}

.tag {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	line-height: 1.5;
	text-align: center;
	white-space: nowrap;

	&.tag-success {
		background-color: rgba(7, 193, 96, 0.1);
		color: #07c160;
		border: 1px solid rgba(7, 193, 96, 0.2);
	}

	&.tag-danger {
		background-color: rgba(245, 108, 108, 0.1);
		color: var(--app-danger);
		border: 1px solid rgba(245, 108, 108, 0.2);
	}

	&.tag-warning {
		background-color: rgba(255, 153, 0, 0.1);
		color: var(--app-warning);
		border: 1px solid rgba(255, 153, 0, 0.2);
	}
}

.text-red {
	color: var(--app-danger);
	font-size: 24px;
	font-weight: 700;
	line-height: 1;
}

::v-deep .el-table__body tr.current-row > td {
	background: var(--app-primary) !important;
	color: var(--app-surface) !important;
}
</style>
